import { render, staticRenderFns } from "./EndOfSessionDialog.vue?vue&type=template&id=3af245df"
import script from "./EndOfSessionDialog.vue?vue&type=script&lang=js"
export * from "./EndOfSessionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports